module.exports = __webpack_public_path__ + "static/media/voucher_fail.716483e2.gif";